import React from "react";
import { PhoneCall, MagnifyingGlass, CheckCircle } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: PhoneCall,
    step: "01",
    title: "Tell us what's wrong",
    desc: "Call, text, or fill out the form. We'll reply within the hour on business days with a quote.",
  },
  {
    icon: MagnifyingGlass,
    step: "02",
    title: "Free diagnostic",
    desc: "On-site or remote, we inspect the device and pinpoint the issue — no obligation, no hidden fees.",
  },
  {
    icon: CheckCircle,
    step: "03",
    title: "Fix & follow-up",
    desc: "Most jobs finish same-day. We follow up in 7 days to make sure everything is running smoothly.",
  },
];

const IMG = "https://images.unsplash.com/photo-1646756089735-487709743361?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjb21wdXRlciUyMHJlcGFpciUyMHRlY2huaWNpYW58ZW58MHx8fHwxNzc3Njg5NTE1fDA&ixlib=rb-4.1.0&q=85";

export default function HowItWorks() {
  return (
    <section id="process" data-testid="process-section" className="bg-zinc-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative rounded-2xl overflow-hidden border border-zinc-200 bg-zinc-100">
            <img
              src={IMG}
              alt="IT technician working on a laptop"
              loading="lazy"
              className="w-full h-full object-cover aspect-[4/5] lg:aspect-auto"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
            <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur rounded-xl p-5 border border-zinc-200">
              <div className="text-xs font-semibold uppercase tracking-widest text-blue-600">Certified</div>
              <div className="mt-1 font-heading text-lg font-bold text-zinc-900">CompTIA A+ & Microsoft Certified Technicians</div>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-widest text-blue-600">How it works</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">
              Three steps. Zero guesswork.
            </h2>
            <p className="mt-4 text-lg text-zinc-600 leading-relaxed">
              Our process is transparent, fast, and respectful of your time. You approve every repair before work begins.
            </p>

            <div className="mt-10 space-y-6">
              {STEPS.map((s, i) => {
                const Icon = s.icon;
                return (
                  <div key={s.step} data-testid={`process-step-${i}`} className="flex gap-5 p-5 rounded-xl bg-white border border-zinc-200">
                    <div className="shrink-0 h-12 w-12 rounded-lg bg-blue-600 grid place-items-center text-white">
                      <Icon size={22} weight="duotone" />
                    </div>
                    <div>
                      <div className="flex items-center gap-3">
                        <span className="text-xs font-mono font-bold text-blue-600">{s.step}</span>
                        <h3 className="font-heading text-lg font-semibold text-zinc-900">{s.title}</h3>
                      </div>
                      <p className="mt-1 text-zinc-600 text-[15px] leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
